module.exports = __webpack_public_path__ + "static/media/Charizard_gaussian2.702c1e49.png";